import { clear } from '@ms/yammer-data/dist/domains/announcements/actions';

import { useDispatchActionCallback } from '../useDispatchActionCallback';

type UseClearAnnouncementsCallback = () => () => void;
export const useClearAnnouncementsCallback: UseClearAnnouncementsCallback = () => useDispatchActionCallback(clear);
